import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';
import {Toggle} from '../../../../../../form/form.jsx';

const FirstMessage = () => {
  const [field, , helpers] = useField('first_message');

  return (
    <Toggle
      label={t`For outgoing messages`}
      isChecked={field.value}
      onChange={helpers.setValue}
    />
  );
};

export default FirstMessage;
